<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions class="justify-content-end mt-4">
    <button type="button" mat-raised-button (click)="closeDialogue(false)">{{data.no}}</button>
    <button type="button" mat-raised-button color="primary" (click)="closeDialogue(true)">{{data.yes}}</button>
</mat-dialog-actions>